"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Authentication_module_1 = tslib_1.__importDefault(require("./modules/Authentication.module"));
const loadShoppingBudgetModule = () => ({
    hasRouter: false,
    modules: [(0, Authentication_module_1.default)()],
});
exports.default = loadShoppingBudgetModule;
